// extracted by mini-css-extract-plugin
module.exports = {"container":"HowItWorksTab_container___BXti","selected":"HowItWorksTab_selected__R5cQ3"};